<template>
  <AntConfigProvider :locale="ruRU" :theme="{token: customTheme}">
    <NotifierIframeBlock />

    <RouterView v-if="keycloakAPI.getIsInit.value" />
    <LoadingPage v-else />
  </AntConfigProvider>
</template>

<script setup lang="ts">
import 'dayjs/locale/ru';

import ruRU from 'ant-design-vue/es/locale/ru_RU';
import dayjs from 'dayjs';

import {customTheme} from '@/config/theme';

import {keycloakAPI} from '@/assets/keycloak';

import AntConfigProvider from '@/assets/ant/config_provider/AntConfigProvider.vue';

import LoadingPage from '@/app/base/pages/LoadingPage.vue';
import NotifierIframeBlock from '@/app/client/components/blocks/NotifierIframeBlock.vue';

dayjs.locale(ruRU.locale);
</script>

<style lang="scss">
@import 'src/assets/styles/defaults';
</style>
